"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.bannedQueryErrorCode = void 0;
// TODO: We shouldn't expose this information and instead treat it as a "excludeQueryTextFromResult" flag,
// not an error.
exports.bannedQueryErrorCode = 1;
//# sourceMappingURL=RequestInterfaces.js.map